import React, { useState, useEffect, useRef} from "react";
//import {Form, Alert } from "react-bootstrap";
import {connect, useSelector} from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import {useMediaQuery, useTheme} from '@material-ui/core';
//import moment from 'moment';
import Grid from '@mui/material/Grid';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
import Chip from '@mui/material/Chip';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {styled} from '@mui/material/styles';
//import CardActionArea from '@material-ui/core/CardActionArea';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Paper from '@material-ui/core/Paper';
import Typography from '@mui/material/Typography';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
//import Card from 'react-bootstrap/Card';
import { Divider, makeStyles } from '@material-ui/core';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
//import ArrowDownward from '@material-ui/icons/ArrowDownward';
//import DataTable from 'react-data-table-component';
//import FormGroup from '@material-ui/core/FormGroup';
//import FormControl from '@material-ui/core/FormControl';
//import TextField from '@material-ui/core/TextField';
//import MaskedInput from 'react-text-mask';
import Button from '@material-ui/core/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MaterialTable from "@material-table/core";
import {MTableToolbar} from "@material-table/core";
import MessageIcon from '@mui/icons-material/Message';
import moment from 'moment';
import {purple} from "@mui/material/colors/index";
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import * as actions from '../store/actions/index';
import * as actionTypes from '../store/actions/actionTypes';

//
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
//
const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    Message: forwardRef((props, ref) => <MessageIcon {...props} ref={ref} />)
};

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    success: {
        color: theme.palette.getContrastText(purple[500])
    },
    header: {
        textAlign: 'left',
        spacing: 10,
    }
}));

const StyledChip = styled(Chip)(({theme}) => ({
    fontSize: 12,
    "& .MuiChip-label":{
      padding: '2px 5px 1px'
    },
    margin: '0px',
    borderRadius: '1px',
    color: '#fff'
}));

function SuperResellerMessage(props) {
    const classes = useStyles();
    const tableRef = useRef();
    const [currentSelectedPage, setCurrentSelectedPage] = useState(props.current_page);
    const [macAddress, setMacAddress] = useState("00:1A:79:");
    const [dataRows, setDataRows] = useState();
    const [filterText, setFilterText] = useState('');
    const [filterData, setFilterData] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [expiredData, setExpiredData] = useState([]);
    const [labelAll, setLabelAll] = useState("ALL");
    const [labelActive, setLabelActive] = useState("ACTIVE");
    const [labelExpired, setLabelExpired] = useState("EXPIRED");
    const [expanded, setExpanded] = React.useState(false);
    const [value, setValue] = React.useState('ALL');
    const [sData, setSData] = useState([]);
    const [message, setMessage] = useState("");
    const [server, setServer] = useState(0);
    const theme = useTheme();
    const isSmallOrLess =
        useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(()=>{
        //props.onGetDealerTransactions(props.token);
        props.onInitializeGetClient();
        props.onInitializeSaveClient();
        props.onInitializeAddClient();
        props.onInitializeDeleteClient();
        props.onInitializeRetrieveCredits();
        props.onInitializeSendMessage();
        props.onGetClientList(props.token, currentSelectedPage, props.searchClients);
    },[]);

    useEffect(()=>{
        if(props.isSuccessSendMessage){
            console.log('redirecting because', props.isSuccessSendMessage);
            //props.onGetCredits(props.token);
            var successMessage = 'Message sent to all selected user(s)';
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
            clearSelection();
            props.onInitializeSendMessage();
            //saveClientRedirect = <Redirect to="/clients" />
        }
    },[props.isSuccessSendMessage]);

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    let clientsData = [];
    useEffect(() => {
        if (props.clients && props.clients.length){
            var currentDate = new Date();
            var now = moment().format('YYYY-MM-DD');

            clientsData = props.clients.map((client) => {
                //console.log('inside client map', client);
                //login: <a href="#" onClick={() => setCurrentClient(client)}>{client.name}</a>,
                var expiry = moment(client.expiry).format('YYYY-MM-DD');
                let clientStatus = client.status ? 'ACTIVE' : 'INACTIVE';
                let expiredClient = moment(now).isAfter(moment(expiry));
                //console.log('Logging now: ', now);
                //console.log('Logging expiry ', client.name, ' ', expiry);

                return {
                    login: client.name,
                    name: client.name,
                    description: client.description,
                    mac: client.ministra ? "" : client.mac,
                    ministra: client.ministra ? "Yes" : "",
                    expiry: moment(client.expiry).format('YYYY-MM-DD'),
                    expired: moment(now).isAfter(moment(expiry)),
                    status: (expiredClient)?"INACTIVE":clientStatus
                };
            });

            let filteredActiveData = clientsData.filter(client => {
                var expiry = moment(client.expiry).format('YYYY-MM-DD');
                if (moment(expiry).isAfter(moment(now))){
                    return true;
                } else {
                    return false;
                }
            });

            let filteredExpiredData = clientsData.filter(client => {
                var expiry = moment(client.expiry).format('YYYY-MM-DD');
                if (moment(now).isAfter(moment(expiry))){
                    return true;
                } else {
                    return false;
                }
            });
            setLabelAll("ALL (" + clientsData.length + ")");
            setLabelActive("ACTIVE (" + filteredActiveData.length + ")");
            setLabelExpired("EXPIRED (" + filteredExpiredData.length + ")");
            setActiveData(filteredActiveData);
            setExpiredData(filteredExpiredData);
            setDataRows(clientsData);
            setFilterData(clientsData);
        }

    },[props.clients]);

    const handleChangeTabs = (event, newValue) => {
        setValue(newValue);
        if (newValue === "ALL"){
            setFilterData(dataRows);
        } else if (newValue === "ACTIVE"){
            setFilterData(activeData);
        } else {
            setFilterData(expiredData);
        }
    };

    const clearSelection = () => {
        // Should check that the element is available to prevent errors
        if (tableRef.current) {
          tableRef.current.onAllSelected(false)
        }
      }

    function handleSubmit(event) {
        event.preventDefault();
        //console.log("login", client.name);
        //console.log("password", client.password);
        //console.log("macaddress", client.mac);
        //console.log("months", months);
        //console.log("description", client.description);
        //console.log("phone", client.phone);
        const data = {
            //name: props.currentDealerName,
            mac: macAddress

        };
        console.log('logging data', data);
        //props.onRetrieveCredits(props.token, data);
        //props.onSearchMac(props.token, macAddress);
    }

    const handleSelectedData = (event, items) => {
        event.preventDefault();
        console.log('logging selected data', items);
        let simpleData = items.map(item => {
            return item.login;
        });

        const data = {
            simpleData: simpleData,
            message: message,
            server: server
        }
        //setSData(data);
        console.log('selected data', simpleData);
        console.log('submit data', data);
        if (message.length == 0){
            let errorMessage = 'Please input a message';
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        } else if (message.length > 300){
            let errorMessage = 'Please reduce the message to below 100 characters!';
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        } else {
            props.onSendMessage(props.token, data);
        }
    }

    function validateForm() {
        return macAddress.length === 17;
    }

    const dataColumnsMaterial = [

        {
            title: 'Login',
            field: 'login',
            cellStyle: {
                fontSize: 13,
                padding: '6px'

            }
        },
        {
            title: 'Description',
            field: 'description',
            hidden: isSmallOrLess,
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            }
        },
        {
            title: 'MAC',
            field: 'mac',
            cellStyle: {
                fontSize: 13,
                padding: '6px'
            }
        },
        {
            title: 'Ministra',
            field: 'ministra',
            hidden: isSmallOrLess,
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            },
            render: (rowData) => (rowData.ministra === 'Yes') ? <Check /> : ""
        },
        {
            title: 'Status',
            field: 'status',
            hidden: isSmallOrLess,
            cellStyle: {
                padding: '6px'
            },
            render: (rowData) => {
                if (rowData.status === 'ACTIVE' && !rowData.expired) {
                    return <StyledChip label={rowData.status} sx={{backgroundColor: '#4caf50'}} size="small"/>;
                } else {
                    return <StyledChip label={rowData.status} sx={{backgroundColor: '#f44336'}} size="small"/>;
                }
            }
        },
        {
            title: 'Expiry',
            field: 'expiry',
            cellStyle: {
                padding: '6px'
            },
            render: (rowData) => (rowData.expired) ? <StyledChip label={rowData.expiry} sx={{backgroundColor: '#f44336'}} size="small"/> : <StyledChip label={rowData.expiry} sx={{backgroundColor: '#4caf50'}} size="small"/>
        }
    ];

    return (
        <Grid container spacing={2}>
            <Grid xs={12} md={12} item>
                    <Card>
                        <CardHeader 
                            title="Message Clients"
                            subheader="Send message to selected User(s). It will take about 5 minutes to deliver the message." 
                            titleTypographyProps={{
                                fontSize: 17,
                                fontWeight: 'bold'
                            }} 
                            subheaderTypographyProps={{
                                fontSize: 14,
                            }}
                        />
                        <Divider variant="middle" />
                        <CardContent sx={{p:1}}>
                            <FormGroup row>
                                <FormControl className={classes.formControl} fullWidth>
                                    <InputLabel id="select-server-label">Server</InputLabel>
                                    <Select
                                        id="server"
                                        labelId="Select server"
                                        value={server}
                                        onChange={e => setServer(e.target.value)}
                                    >
                                        <MenuItem value={0} key="server_0">TITAN 4K</MenuItem>
                                        <MenuItem value={1} key="server_1">COD 4K</MenuItem>
                                        <MenuItem value={2} key="server_2">CROWN 4K</MenuItem>
                                    </Select>
                                </FormControl>
                            </FormGroup>
                            <Box
                                component="form"
                                sx={{
                                    '& > :not(style)': { m: 0 },
                                }}
                                noValidate
                                autoComplete="off"
                                >
                                <TextField 
                                    fullWidth 
                                    id="standard-message" 
                                    label="Type message here" 
                                    error={message.length > 300 || message.length == 0}
                                    helperText={(message.length>300)?"Message is too long":""}
                                    value={message}
                                    onChange={e => setMessage(e.target.value)} 
                                    variant="filled"
                                    />
                            </Box>
                            <MaterialTable
                                tableRef={tableRef}
                                icons={tableIcons}
                                columns={dataColumnsMaterial}
                                data={filterData}
                                title=""
                                actions={[
                                    {
                                      tooltip: 'Send message to All Selected Users',
                                      icon: tableIcons.Message,
                                      onClick: (evt, data) => handleSelectedData(evt, data)
                                    }
                                  ]}
                                options={{
                                    pageSize: 10,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [10, 20, 30, 40, 50, 100],
                                    padding: "dense",
                                    headerStyle: {padding: '5px', fontWeight: 'bold', fontSize: 13},
                                    tableLayout: "auto",
                                    selection: true
                                }}
                                components={{
                                    Toolbar: props => (
                                    <div>
                                    <MTableToolbar {...props} />
                                    <div style={{padding: '0px 10px'}}>
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>

                                            <Tabs
                                                value={value}
                                                onChange={handleChangeTabs}
                                                textColor="inherit"
                                                indicatorColor="primary"
                                                aria-label="secondary tabs"

                                            >
                                                <Tab sx={{fontSize: 12}} value="ALL" label={labelAll} />
                                                <Tab sx={{fontSize: 12}} value="ACTIVE" label={labelActive} />
                                                <Tab sx={{fontSize: 12}} value="EXPIRED" label={labelExpired} />
                                            </Tabs>
                                        </Box>
                                    </div>
                                    </div>
                                    ),
                                }}
                            />
                        </CardContent>
                    </Card>

            </Grid>
        </Grid>

    );
}

const mapDispatchToProps = dispatch => {
    return {
        //onSearchMac: (token, mac) => dispatch(actions.searchMac(token, mac)),
        onGetClientList: (token, page, search) => dispatch(actions.clientListSuperReseller(token, page, search)),
        onSendMessage: (token, data) => dispatch(actions.sendMessageSuperReseller(token, data)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message)),
        onInitializeGetClient: () => dispatch(actions.initializeGetClient()),
        onInitializeAddClient: () => dispatch(actions.initializeAddClient()),
        onInitializeSaveClient: () => dispatch(actions.initializeSaveClient()),
        onInitializeDeleteClient: () => dispatch(actions.initializeDeleteClient()),
        onInitializeRetrieveCredits: () => dispatch(actions.initializeRetrieveCredits()),
        onInitializeSendMessage: () => dispatch(actions.initializeSendMessage())
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        clients: state.clients.client_list,
        isLoading: state.clients.loading,
        current_page: state.clients.current_page,
        //searchMac: state.searchMac.found,
        isLoadingSendMessage: state.sendMessage.loading,
        isFailSendMessage: state.sendMessage.error,
        isSuccessSendMessage: state.sendMessage.data
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperResellerMessage);